import React from "react";
import HomeContentStyles from "./HomeContent.module.css";
import homeImage from "../Assests/homeImage.jpg";
import { Link } from "react-scroll";
import Azure1 from "../Assests/azure1.png"
import Azure2 from "../Assests/azure2.png"

const HomeContent = () => {
  return (
    <section className={HomeContentStyles.HomeContent}>
      <div className={HomeContentStyles.HomeContent_left_main}>
        <div className={HomeContentStyles.Socialicons}>
          <a href="https://github.com/praveendecode" target="_blank">
            <i className="fa-brands fa-github"></i>
          </a>
          <a href="http://www.linkedin.com/in/dev-praveen-n" target="_blank">
            <i className="fa-brands fa-linkedin"></i>
          </a>
          <a href="mailto:code.praveendev@gmail.com">
            <i className="fa-solid fa-envelope"></i>
          </a>
        </div>

        <div className={HomeContentStyles.HomeContent_left}>
          <h1>
            <span>I'm</span> Praveen
          </h1>
          <div className={HomeContentStyles.sub_content}> 
          <h2 className={HomeContentStyles.creative_dev}>
            <span>Certified</span> Data Scientist
          </h2>
          <img src={Azure2} alt="" />
          </div>
          <h5>
            Microsoft Certified Data Scientist, I specialize in model selection,
            deployment of application and proficiency in Python, Docker, SQL,
            and NoSQL databases. My experience spans various ML and NLP
            projects, where I've derived insights, provided recommendations, and
            I am now seeking employment opportunities to apply and expand my
            expertise in a data Science Domain
          </h5>
          <div className={HomeContentStyles.Certifycontent}>
          <div className={HomeContentStyles.HomeContent_left_btn}>
            <a
              href="https://drive.google.com/file/d/1ZcoT5pM0WGBnSynAyXVaJmwqw31UePYG/view"
              target="_blank"
            >
              <button className={HomeContentStyles.btn_resume}>Resume</button>
            </a>
            <Link to="projects" smooth={true} duration={500}>
              <button className={HomeContentStyles.btn_work}>My Work</button>
            </Link>
          </div>
          </div>
        </div>
      </div>
      <div className={HomeContentStyles.HomeContent_right}>
        <img src={homeImage} alt="" />
      </div>
    </section>
  );
};
export default HomeContent;
